/**
 * 插件集合 Vue 插件
 * 将现有的插件实现包装成 Vue 插件形式，确保在正确的时机执行
 */
const PluginsPlugin = {
  install() {
    console.log("插件集合已通过 Vue.use 方式加载");

    // 在 install 方法中动态导入和执行插件文件
    // 确保在 Vue 应用实例准备好之后才执行
    // import("./request").then(() => console.log("插件挂载完成"));
    // import("./request");

    import("./marketing-popup");

    import("./power-reminder");
    import("./version-check");



    // 如果将来需要访问 app 实例，可以在这里处理
    // app.config.globalProperties.$xxx = xxx
  }
};

export default PluginsPlugin;
